import axios from 'axios';

const axiosNominatimInstance = axios.create({
  baseURL: 'https://nominatim.openstreetmap.org/',
});

export const nominatimAPI = {
  searchByAddress: address => axiosNominatimInstance.get(`search?format=json&limit=15&addressdetails=1&exclude_place_ids=257572097&q=${address}`),

  searchByCoordinates: (lat, lon) => axiosNominatimInstance.get(
    `reverse?format=json&accept-language=en&lon=${lon}&lat=${lat}`
  ),
};
